<template>
    <div>
        <slot name="title"></slot>

        <div class="g-container c-collapse" v-if="showButton">
            <button type="button" @click="expand(!isExpanded())" :style="{'margin-top': moveTop}" class="u-pull-right c-button c-button--transparent c-button--expand c-button--aqua c-collapse__button" v-html="expandLabel"></button>
        </div>

        <slot>
            <!---->
        </slot>
    </div>
</template>
<script lang="ts">
import has from 'lodash/has';
import { Component, Prop } from 'vue-property-decorator';
import { dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import Calculator from '../helpers/calculator';
import { implementsInterface } from '../helpers/utils';
import { Expandable } from './AccordionTypes';
import BaseComponent from './Base';

/**
     * Use url hash or 'expandIndex' pops for opening the tab by number.
     * Use a numbering from 1. Not from 0.
     */
    @Component
    export default class Accordion extends BaseComponent implements Expandable {
        @Prop({ type: [Boolean], default: true }) protected readonly showButton: boolean;
        @Prop({ type: [Number, Boolean], default: false }) protected readonly expandIndex: number | boolean;
        @Prop({ type: String, default: 'Accordion' }) protected readonly gtmCategory: string;
        @Prop({ type: [Boolean], default: false }) protected readonly expanded: boolean;
        @Prop({ type: String, default: '0' }) protected readonly moveTop: string;

        protected expandables: Expandable[] = [];

        public expand(state?: boolean): void {
            if (state) {
                dataLayer.push({
                    eventAction: 'Expanded',
                    eventLabel: 'Expanded All',
                    eventCategory: this.gtmCategory,
                    event: 'accordion:expanded',
                });
            } else {
                dataLayer.push({
                    eventAction: 'Folded',
                    eventLabel: 'Folded All',
                    eventCategory: this.gtmCategory,
                    event: 'accordion:folded',
                });
            }
            this.expandables.forEach((item) => {
                item.expand(state);
            });
        }

        public isExpanded(): boolean {
            return this.expandables.find((item) => !item.isExpanded()) === undefined;
        }

        public getIndex(): number | undefined {
          return undefined;
        }

        public findItemByIndex(index: number): Expandable | undefined {
          return this.expandables.find((item) => index === item.getIndex());
        }

        get expandLabel(): string {
            const isExpanded = this.isExpanded();
            const label = this.t(isExpanded ? 'Fold All' : 'Expand All');
            return `${label} <i class="u-fa u-fa-angle-${isExpanded ? 'up' : 'down'}"></i>`;
        }

        public mounted(): void {
            this.$children.forEach((child) => {
                if (implementsInterface<Expandable>(child, 'expand', 'function')) {
                    this.expandables.push(child);
                }
            });

            // If hash is added to the page url, open the corresponding accordion tab.
            if (location.hash) {
                const tabIdx: number = parseInt(location.hash.substr(1), 10);
                if (Calculator.isNumeric(tabIdx) && has(this.expandables, tabIdx - 1)) {
                    this.openItemByIndex(tabIdx - 1);
                }
                return;
            }

            // If not, open the tab, specified in component options.
            if (typeof this.expandIndex !== 'boolean') {
                this.openItemByIndex(this.expandIndex - 1);
            }

            if (this.expanded) {
                this.expand(this.expanded);
            }
        }

        protected openItemByIndex(index: number): void {
          const tab = this.findItemByIndex(index);
          if (tab) {
            tab.expand(true);
            EventBus.$emit('shouldScrollTo', {
              top: tab.$el.getBoundingClientRect().top - 100,
            });
          }
        }
    }
</script>
<style lang="scss">
.is-active {
    .c-tour-program {
        &__head {
            color: #000;
        }
    }
}

</style>
